import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const categoryIcons: Record<string, string> = {
  "zhibo-zixun": "ri-newspaper-line",
  "lanmu-tuijian": "ri-tv-2-line",
  "shiyong-jiaocheng": "ri-book-open-line",
  "pingtai-dongtai": "ri-rocket-line",
};

const categoryColors: Record<string, string> = {
  "zhibo-zixun": "bg-primary-100 text-primary-700",
  "lanmu-tuijian": "bg-accent-100 text-accent-700",
  "shiyong-jiaocheng": "bg-secondary-100 text-secondary-700",
  "pingtai-dongtai": "bg-accent-100 text-accent-700",
};

export default function HomeCategories() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            内容分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按分类浏览，快速找到您感兴趣的直播内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-lg mb-4 ${categoryColors[cat.slug] || "bg-primary-100 text-primary-700"}`}
              >
                <i className={`${categoryIcons[cat.slug] || "ri-folder-line"} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center gap-1 mt-4 text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>浏览更多</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}